import { getEnvVariable } from "../util/environment.js";
import { JwAuthError } from "../auth/error.js";
import { parseQueryParams } from "../fetch/util.js";
import { wrappedFetch } from "../fetch/index.js";
import { joinUrl } from "../util/url.js";
import { parseListParams } from "./list-operation/index.js";

//#region ../base/api/index.ts
const parseResourcePath = (endpoint, routeParams, queryParams) => {
	let ret = endpoint;
	if (routeParams) for (const [key, value] of Object.entries(routeParams)) ret = ret.replace(`:${key}`, value ? String(value) : "");
	const matches = ret.match(/:([\w\d]+)/gim);
	if (matches !== null) throw new Error(`Missing route param(s): ${matches.map((m) => m.substring(1))}`);
	if (queryParams) {
		const usp = new URLSearchParams();
		parseQueryParams(usp, queryParams);
		parseListParams(usp, queryParams);
		const queryString = usp.toString();
		if (queryString) ret += `?${queryString}`;
	}
	return ret;
};
const parseInput = async (input, zodObject, transformFn) => {
	let ret;
	if (zodObject) {
		const parsed = zodObject.safeParse(input);
		if ("error" in parsed && parsed.error) throw new Error(parsed.error.toString());
		ret = parsed.data;
	}
	if (transformFn) ret = await transformFn(ret);
	return ret;
};
async function request({ baseUrl, operations }, action, params, { debug, authToken, transformHeaders,...opts } = {}) {
	const operation = operations[action];
	let { routeParams } = params;
	if (operation.authenticated && !authToken) throw new JwAuthError("MISSING_TOKEN");
	if (operation.transform?.routeParams && routeParams) routeParams = operation.transform.routeParams(routeParams);
	const inputTransformed = await parseInput(params.input, operation.input, operation.transform?.input);
	const headersTransformed = await parseInput(params.headers, operation.headers, operation.transform?.headers);
	const queryParamsTransformed = await parseInput(params.queryParams, operation.queryParams);
	const parsedPath = parseResourcePath(operation.path, routeParams, queryParamsTransformed);
	const fullUrl = joinUrl(baseUrl(), parsedPath);
	try {
		const { data,...finalRes } = await wrappedFetch(fullUrl, {
			...opts,
			method: operation.method,
			body: inputTransformed,
			headers: {
				...headersTransformed,
				...opts.headers
			}
		}, {
			authToken: operation.authenticated ? authToken : void 0,
			inputType: operation.inputType,
			responseType: operation.responseType,
			mockFetch: operation.mockFetch,
			debug,
			transformHeaders
		});
		let finalData = data;
		if (operation.transform?.output) {
			finalData = await operation.transform.output(data, {
				routeParams,
				queryParams: queryParamsTransformed,
				input: params.input
			});
			if (debug) console.debug("Transformed:", JSON.stringify(finalData, null, 2));
		}
		operation.events?.onSuccess?.(finalData);
		if (getEnvVariable("TEST")) finalRes.__operation__ = operation;
		return {
			...finalRes,
			data: finalData
		};
	} catch (err) {
		operation.events?.onError?.(err);
		throw err;
	}
}

//#endregion
export { request };